module.exports = __webpack_public_path__ + "static/media/97.a6a7f26d.jpg";